"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _common = require("modules/common");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _ReopenComplaintForm = require("./components/ReopenComplaintForm");

var _ReopenComplaintForm2 = _interopRequireDefault(_ReopenComplaintForm);

var _actions = require("egov-ui-kit/redux/complaints/actions");

var _actions2 = require("egov-ui-kit/redux/form/actions");

var _form = require("egov-ui-kit/hocs/form");

var _form2 = _interopRequireDefault(_form);

var _api = require("egov-ui-kit/utils/api");

var _actions3 = require("egov-ui-kit/redux/app/actions");

var _components = require("egov-ui-kit/components");

require("./index.css");

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReopenComplaintFormHOC = (0, _form2.default)({ formKey: "reopenComplaint", isCoreConfiguration: true, path: "pgr" })(_ReopenComplaintForm2.default);

var ReOpenComplaint = function (_Component) {
  (0, _inherits3.default)(ReOpenComplaint, _Component);

  function ReOpenComplaint() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReOpenComplaint);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReOpenComplaint.__proto__ || Object.getPrototypeOf(ReOpenComplaint)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      valueSelected: "",
      optionid: "",
      commentValue: "",
      options: [],
      loadingStatus: false
    }, _this.options = [{ value: "No work was done", label: _react2.default.createElement(_translationNode2.default, { label: "CS_REOPEN_OPTION_ONE" }) }, { value: "Only partial work was done ", label: _react2.default.createElement(_translationNode2.default, { label: "CS_REOPEN_OPTION_TWO" }) }, { value: "Employee did not turn up", label: _react2.default.createElement(_translationNode2.default, { label: "CS_REOPEN_OPTION_THREE" }) }, { value: "No permanent solution", label: _react2.default.createElement(_translationNode2.default, { label: "CS_REOPEN_OPTION_FOUR" }) }], _this.commentsValue = {}, _this.handleCommentChange = function (e, value) {
      _this.commentsValue.textVal = e.target.value;
      _this.setState({
        commentValue: e.target.value
      });
      _this.concatComments(_this.commentsValue);
    }, _this.handleOptionsChange = function (event, value) {
      _this.setState({ valueSelected: event.label });
      _this.setState({ optionid: event.value });
      _this.commentsValue.radioValue = event.label;
      _this.concatComments(_this.commentsValue);
    }, _this.concatComments = function (val) {
      var optionid = _this.state.optionid;

      var com1 = "";
      var com2 = "";
      if (val.radioValue) {
        com1 = val.radioValue + ";";
      }
      if (val.textVal) {
        com2 = val.textVal;
      }
      var concatvalue = com1 + com2;
      _this.props.handleFieldChange("reopenComplaint", "comments", concatvalue);
    }, _this.onSubmit = function (e) {
      _this.setState({
        loadingStatus: true
      });

      var state = _store2.default.getState();
      var isMediaExist = state.form && state.form.reopenComplaint && state.form.reopenComplaint.files ? state.form.reopenComplaint.files.media.length > 0 ? true : false : false;

      var _this$state = _this.state,
          valueSelected = _this$state.valueSelected,
          optionid = _this$state.optionid,
          commentValue = _this$state.commentValue;
      var toggleSnackbarAndSetText = _this.props.toggleSnackbarAndSetText;

      if (valueSelected === "Other" && !commentValue) {
        _this.setState({
          loadingStatus: false
        });

        e.preventDefault();
        toggleSnackbarAndSetText(true, {
          labelName: "Please mention your reason",
          labelKey: "Please mention your reason"
        }, "error");
      }

      // check whether reason exist or not
      if (valueSelected == "") {
        _this.setState({
          loadingStatus: false
        });

        e.preventDefault();
        toggleSnackbarAndSetText(true, {
          labelName: "Please provide required values!",
          labelKey: "Please provide required values!"
        }, "error");
      } else if (valueSelected) {
        var loginUserRole = localStorage.getItem("rolename");
        loginUserRole = loginUserRole && loginUserRole.toUpperCase();
        var rolecode = loginUserRole === "D.G" || loginUserRole === "PGR_LME" ? "PGR_LME" : loginUserRole === "GRO" ? "GRO" : loginUserRole === "ESCALATION_OFFICER1" ? "ESCALATION_OFFICER1" : loginUserRole === "ESCALATION_OFFICER2" ? "ESCALATION_OFFICER2" : "";

        _this.props.handleFieldChange("reopenComplaint", "rolecode", rolecode);
        _this.props.handleFieldChange("reopenComplaint", "optionid", optionid);
        _this.setState({
          loadingStatus: false
        });
      } else {
        _this.setState({
          loadingStatus: false
        });

        e.preventDefault();
        toggleSnackbarAndSetText(true, {
          labelName: "Please provide required values!",
          labelKey: "Please provide required values!"
        }, "error");
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ReOpenComplaint, [{
    key: "componentDidMount",
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _props, fetchComplaints, match, requestData, payload, options;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, fetchComplaints = _props.fetchComplaints, match = _props.match;

                _store2.default.dispatch((0, _actions2.removeForm)("reopenComplaint"));
                fetchComplaints([{ key: "serviceRequestId", value: match.params.serviceRequestId }]);
                requestData = {
                  action: "reopen"
                };
                _context.next = 6;
                return (0, _api.httpRequestForPT)("/rainmaker-pgr/v1/requests/getOptions", "", [], requestData, [], {}, true);

              case 6:
                payload = _context.sent;

                if (payload.status == 200) {
                  options = payload.data.map(function (item) {
                    return {
                      value: item.optionid,
                      label: item.optionName
                    };
                  });

                  this.setState({
                    options: options
                  });
                } else {
                  this.props.toggleSnackbarAndSetText(true, {
                    labelName: "Error",
                    labelKey: "Error"
                  }, "error");
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref2.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var handleCommentChange = this.handleCommentChange,
          onSubmit = this.onSubmit,
          handleOptionsChange = this.handleOptionsChange;
      var _state = this.state,
          valueSelected = _state.valueSelected,
          commentValue = _state.commentValue,
          options = _state.options,
          loadingStatus = _state.loadingStatus;
      var userInfo = this.props.userInfo;

      var role = userInfo && userInfo.roles && userInfo.roles.length && userInfo.roles[0].code.toLowerCase() || null;

      return _react2.default.createElement(
        _common.Screen,
        { className: "background-white" },
        loadingStatus && _react2.default.createElement(_components.LoadingIndicator, null),
        _react2.default.createElement(ReopenComplaintFormHOC, {
          options: options,
          ontextAreaChange: handleCommentChange,
          handleOptionChange: handleOptionsChange,
          optionSelected: valueSelected,
          commentValue: commentValue,
          onSubmit: onSubmit,
          role: role
        })
      );
    }
  }]);
  return ReOpenComplaint;
}(_react.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fileUpload: function fileUpload(formKey, fieldKey, file) {
      return dispatch((0, _actions2.fileUpload)(formKey, fieldKey, file));
    },
    fetchComplaints: function fetchComplaints(criteria) {
      return dispatch((0, _actions.fetchComplaints)(criteria));
    },
    handleFieldChange: function handleFieldChange(formKey, fieldKey, value) {
      return dispatch((0, _actions2.handleFieldChange)(formKey, fieldKey, value));
    },
    toggleSnackbarAndSetText: function toggleSnackbarAndSetText(open, message, error) {
      return dispatch((0, _actions3.toggleSnackbarAndSetText)(open, message, error));
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ReOpenComplaint);


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/pgr/ReOpenComplaint/index.js
// module id = 3387
// module chunks = 1137